import gql from "graphql-tag";

// note - custom_attribute_value is a graphql alias configured in hasura for brevity
export const CUSTOM_ATTRIBUTE_VALUE_FRAGMENT = gql`
  fragment customAttributeValueFields on custom_attribute_value {
    id
    attribute_id
    label
    org_id
    created_by_user_uid
    created_by_user_uuid_internal
    value
  }
`;
